<script setup lang="ts">
const props = defineProps<{
    title?: string;
}>();
</script>

<template>
    <select class="form-control select2-enabled" :data-placeholder="props.title" :title="props.title">
        <option value="EUR" selected>
            Euro
        </option>
        <option value="USD">
            US Dollar
        </option>
        <option value="GBP">
            Pound Sterling
        </option>
        <option value="CHF">
            Swiss Franc
        </option>
        <option value="JPY">
            Japanese Yen
        </option>
        <option value="CNY">
            Chinese Yuan
        </option>
        <option value="RUB">
            Russian Ruble
        </option>
    </select>
</template>
